<template lang="">
  <div>
    <v-dialog v-model="dialog" width="620px">
      <v-card>
        <v-card-title class="primary white--text"
          ><v-toolbar-title>CẤU HÌNH TÀI KHOẢN HỌC PHÍ</v-toolbar-title>
          <v-spacer />
          <v-icon color="white" @click="cancel">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-form ref="form" flat class="pa-6 mb-10" lazy-validation>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="bank"
                :items="banks"
                label="Ngân hàng"
                item-text="shortName"
                item-value="shortName"
                no-data-text="Danh sách trống"
                clearable
                clear-icon="mdi-close"
                dense
                outlined
                hide-details
                return-object
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="accountNumber"
                label="Số tài khoản"
                placeholder="Nhập tên ngân hàng"
                outlined
                required
                dense
                class="required style"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="accountName"
                label="Tên chủ tài khoản"
                placeholder="Nhập tên chủ tài khoản"
                outlined
                required
                dense
                class="required style"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel"
            >Hủy</v-btn
          >
          <v-spacer />
          <v-btn depressed color="primary" class="px-6 mr-4 mt-n4 mb-2 white--text" @click="save">Lưu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      bank: '',
      accountNumber: '',
      accountName: '',
    }
  },
  methods: {
    ...mapActions({
      update: 'schoolBankAccount/update',
      fetch: 'schoolBankAccount/fetch',
    }),
    async openDialog(item, banks) {
      this.banks = banks
      if (item) {
        this.bank = item.bankCode
        this.accountNumber = item.accountNumber
        this.accountName = item.accountName
      }
      this.dialog = true
    },
    cancel() {
      this.dialog = false
    },
    async save() {
      try {
        this.$loading.active = true
        if (!this.$refs.form.validate()) return
        const data = {
          bankName: this.bank.name,
          bankCode: this.bank.shortName,
          bin: this.bank.bin,
          accountNumber: this.accountNumber,
          accountName: this.accountName,
        }
        await this.update(data)
        await this.$alert.success('Câp nhật thành công')
        await this.fetch()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
        this.dialog = false
      }
    },
  },
}
</script>
<style lang="css" scoped></style>
